import ApiService from './api.service'

const PREFIX = '/contragent';
const MONEY_TRANSFER = '/money-transfer';
const CONTRAGENT_ORDERS = '/contragent-orders'


const ContrAgentService = {

	//contragent request to department api begin
	searchContragent: function (data) {
		return ApiService.post(`${PREFIX}/search`, data);
	},
	editManagerOrderDoc(id, data) {
		return ApiService.post(`${CONTRAGENT_ORDERS}/manager-edit/${id}`, data);
	},
	getDocumentItems(id) {
		return ApiService.get(`${CONTRAGENT_ORDERS}/get/${id}`);
	},
	receiveManager(id) {
		return ApiService.post(`${CONTRAGENT_ORDERS}/receive-manager/${id}`);
	},
	getOrdersList(data) {
		return ApiService.post(`${CONTRAGENT_ORDERS}/search`, data);
	},
	createOrder(data) {
		return ApiService.post(`${CONTRAGENT_ORDERS}/create`, data);
	},
	//manager page api.
	getOrdersListOnProcessForContragentAccount(data) {
		return ApiService.post(`${CONTRAGENT_ORDERS}/search/on-process-for-contragent`, data);
	},
	getOrdersListNewDocsForContragent(data) {
		return ApiService.post(`${CONTRAGENT_ORDERS}/search/new-and-suspend-docs`, data);
	},
	getOrdersListOnProcess(data) {
		return ApiService.post(`${CONTRAGENT_ORDERS}/search/on-process`, data);
	},
	getOrdersListArxiv(data) {
		return ApiService.post(`${CONTRAGENT_ORDERS}/search/arxiv`, data);
	},
	getOrdersListNewDocs(data) {
		return ApiService.post(`${CONTRAGENT_ORDERS}/search/new-docs`, data);
	},
	createWholeSaleDoc(data) {
		return ApiService.post(`${CONTRAGENT_ORDERS}/create/booking`, data);
	},
	//manager page api end
	//contragent request to department api end
	search: function (data) {
		return ApiService.post(`${PREFIX}/search`, data);
	},
	storeOrUpdate: function (data) {
		return ApiService.post(`${PREFIX}/add-or-update`, data);
	},
	saldoMoneyTransfer: function (data) {
		return ApiService.post(`${MONEY_TRANSFER}/income`, data);
	},
	getSaldoByYear: function (payload) {
		return ApiService.post(`${MONEY_TRANSFER}/getsaldo`, payload);
	},
	getConragentSaldo: function (payload) {
		return ApiService.post(`${MONEY_TRANSFER}/getConragentSaldo/${payload}`);
	},
	deleteContragent: function (contragentId) {
		return ApiService.delete(`${PREFIX}/delete/${contragentId}`);
	},
	getContragentById: function (contragentId) {
		return ApiService.get(`${PREFIX}/get/${contragentId}`)
	},
};

export default ContrAgentService;
